<template>
  <div class="app-news">
    <div class="news-menu">
      <el-menu
        :default-active="activeIndex"
        class="news-nav"
        mode="vertical"
        @select="handleSelect"
      >
        <el-menu-item v-for="(item, index) of categories" :key="index" :index="String(item.id)">{{ item.title }}</el-menu-item>
      </el-menu>
    </div>
    <div class="news-content">
      <!-- 面包屑导航 -->
      <el-breadcrumb separator="/" class="breadcrumb" v-if="showDetail">
        <el-breadcrumb-item>新闻资讯</el-breadcrumb-item>
        <el-breadcrumb-item v-if="currentCategory">{{ currentCategory.title }}</el-breadcrumb-item>
      </el-breadcrumb>

      <!-- 文章列表 -->
      <div v-if="!showDetail" class="article-list">
        <el-empty v-if="!loading && newsList.length === 0" description="暂无数据" />
        <el-skeleton v-else-if="loading" :rows="5" animated />
        <template v-else>
          <div v-for="(item, index) in newsList" :key="index" class="news-item" @click="showArticleDetail(item)">
            <div class="item-img">
              <el-image :src="item.image || require('@/assets/news/new_bg.jpg')" fit="cover" />
            </div>
            <div class="item-content">
              <h3>{{ item.title }}</h3>
              <p class="content-body">
                <span v-html="$formatContent(item.content)"></span>
                <span class="show-more" @click="showArticleDetail(item)">查看更多</span>
              </p>
              <div class="item-date">
                <span>{{ new Date(item.create_time).getDate() }}</span>
                <span>{{ formatMonth(item.create_time) }}</span>
              </div>
            </div>
          </div>
        </template>
      </div>

      <!-- 文章详情 -->
      <div v-else class="article-detail">
        <div class="article-content">
          <h1 class="title">{{ detail.title }}</h1>
          <div class="meta">
            <span class="time">{{ formatTime(detail.create_time) }}</span>
          </div>
          <div class="content" v-html="detail.content"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { articleInfo, articleList, articleClass } from '@/api/index'

export default {
  name: 'AppNews',
  data() {
    return {
      categories: [], // 文章分类
      newsList: [], // 文章列表
      detail: {}, // 文章详情
      activeIndex: null, // 当前选中的菜单项
      classify_id: null, // 分类id
      loading: false, // 加载状态
      showDetail: false, // 是否显示详情
      currentCategory: null // 当前分类
    }
  },
  created() {
    this.classify_id = this.$route.query.classify_id || null;
    this.activeIndex = this.$route.query.id || null;
    // 确保页面刷新时也能获取到导航和底部数据
    this.$store.dispatch('getHomeData').then(() => {
      this.getCategories()
    })
  },
  methods: {
    // 获取文章分类
    getCategories() {
      articleClass({classify_id: this.classify_id}).then(res => {
        if (res.data) {
          this.categories = res.data.rows
          if (this.categories.length > 0) {
            this.activeIndex = String(this.categories[0].id)
            this.currentCategory = this.categories[0]
            this.getArticleList(this.categories[0].id)
          }
        }
      })
    },
    // 获取文章列表
    getArticleList(id) {
      this.loading = true
      articleList({
        classify_id: id
      }).then(res => {
        this.loading = false
        if (res.data.rows) {
          this.newsList = res.data.rows.filter(item => item.status !== 0)
        } else {
          this.newsList = []
        }
      }).catch(() => {
        this.loading = false
      })
    },
    // 获取文章详情
    getArticleDetail(id) {
      articleInfo({id: id}).then(res => {
        this.detail = res.data
      })
    },
    // 菜单选择事件
    handleSelect(key) {
      this.showDetail = false
      this.activeIndex = key
      const category = this.categories.find(item => String(item.id) === String(key))
      if (category) {
        this.currentCategory = category
        this.getArticleList(category.id)
      }
    },
    // 显示文章详情
    showArticleDetail(item) {
      this.showDetail = true
      this.detail = item
      this.getArticleDetail(item.id)
    },
    // 格式化时间
    formatTime(time) {
      if (!time) return ''
      const date = new Date(time)
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
    },
    // 格式化月份
    formatMonth(time) {
      if (!time) return ''
      const date = new Date(time)
      return `${String(date.getMonth() + 1).padStart(2, '0')}月`
    }
  }
}
</script>

<style lang="scss" scoped>
.app-news {
  margin: 10px auto;
  display: flex;
  max-width: 1200px;
  min-height: calc(100vh - 60px);
  background-color: #fff;

  .news-menu {
    width: 200px;
    border-right: 1px solid #EBEEF5;

    .news-nav {
      border-right: none;

      .el-menu-item {
        height: 50px;
        line-height: 50px;
        padding: 0 15px;
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        transition: all 0.3s;
        position: relative;

        &:hover {
          background-color: #f5f7fa;
          color: #409EFF;
        }

        &.is-active {
          color: #409EFF;
        }
      }
    }
  }

  .news-content {
    flex: 1;
    padding: 20px;
    overflow: hidden;

    .breadcrumb {
      margin-bottom: 20px;
    }

    .article-list {
      .news-item {
        display: flex;
        align-items: center;
        padding: 20px;
        border-bottom: 1px solid #EBEEF5;
        cursor: pointer;
        transition: all 0.3s;

        &:hover {
          background-color: #F5F7FA;
        }

        .item-img {
          width: 120px;
          height: 80px;
          margin-right: 20px;
          overflow: hidden;
          border-radius: 4px;

          .el-image {
            width: 100%;
            height: 100%;
          }
        }

        .item-content {
          flex: 1;
          position: relative;
          padding-right: 100px;

          h3 {
            margin: 0 0 10px;
            font-size: 16px;
            color: #303133;
          }

          .content-body {
            margin: 0;
            color: #909399;
            font-size: 14px;
            line-height: 1.6;

            .show-more {
              color: #409EFF;
              cursor: pointer;
              margin-left: 5px;

              &:hover {
                text-decoration: underline;
              }
            }
          }

          .item-date {
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            text-align: center;
            color: #f56c6c;

            span {
              display: block;

              &:first-child {
                font-size: 24px;
                font-weight: bold;
              }

              &:last-child {
                font-size: 12px;
                margin-top: 5px;
              }
            }
          }
        }
      }
    }

    .article-detail {
      padding: 20px;

      .article-content {
        .title {
          font-size: 24px;
          color: #303133;
          margin-bottom: 20px;
          text-align: center;
        }

        .meta {
          text-align: center;
          color: #909399;
          margin-bottom: 30px;

          .time {
            margin-right: 20px;
          }
        }

        .content {
          line-height: 1.8;
          color: #606266;

          img {
            max-width: 100%;
            height: auto;
            margin: 10px 0;
          }

          p {
            margin: 10px 0;
          }
        }
      }
    }
  }
}
</style>